import styled from 'styled-components';
import MediaSizes from '@widgets/shared/MediaSizes';
export const Wrapper = styled.ul `
  margin: 0;
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  align-content: flex-start;
  gap: 0.4rem;
  width: 100%;
  max-width: 40rem;
  color: #000;
  font-family: var(--body-font);
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 100%;

  li {
    display: flex;
    align-items: center;
    gap: 0.6rem;
    margin: 0;
    padding: 0.7rem 1.2rem 0.7rem 1rem;
    border: 0.1rem solid var(--border, #e7e6eb);
    border-radius: 3rem;
    background: #fff;
    white-space: nowrap;

    &::before {
      content: "";
      flex-shrink: 0;
      display: block;
      width: 0.8rem;
      height: 0.8rem;
      border: 0;
      border-radius: 0.8rem;
    }
  }

  ${({ theme: { availabilityKey } }) => availabilityKey}

  @media screen and (max-width: ${MediaSizes.XS_MAX}px) {
    max-width: 100%;
  }
`;
export const HighAvailability = styled.li `
  &::before {
    background-color: var(--high-availability);
  }
`;
export const AverageAvailability = styled.li `
  &::before {
    background-color: var(--average-availability);
  }
`;
export const LowAvailability = styled.li `
  &::before {
    background-color: var(--low-availability);
  }
`;
export const NoAvailability = styled.li `
  &::before {
    background-color: var(--no-availability, #a6a6a6);
  }
`;
export default {
    Wrapper,
};
